import React, { useEffect } from 'react';
import { getCookie } from './cookies';

const MEASUREMENT_ID = 'G-0J56W03TTX';
const GA_DISABLE_FLAG = `ga-disable-${MEASUREMENT_ID}`;

// Applies consent to GA (grant/deny) and toggles the disable flag.
function applyConsent(consent: 'granted' | 'denied') {
  if (typeof window === 'undefined') return;
  (window as any)[GA_DISABLE_FLAG] = consent === 'denied';
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', { analytics_storage: consent });
  }
}

// Exported for the banner to toggle consent live.
export function updateGaConsent(consent: 'granted' | 'denied') {
  applyConsent(consent);
}

// Loads GA; defaults to tracking unless explicitly declined.
const GoogleAnalytics: React.FC = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const consentCookie = getCookie('ntc_cookie_consent');
    const consent = consentCookie === 'declined' ? 'denied' : 'granted';

    applyConsent(consent);

    if (!document.getElementById('ga-gtag')) {
      const script = document.createElement('script');
      script.id = 'ga-gtag';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
      document.head.appendChild(script);

      const inlineScript = document.createElement('script');
      inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${MEASUREMENT_ID}', { anonymize_ip: true });
      `;
      document.head.appendChild(inlineScript);
    }

    // Ensure gtag exists before firing page view
    window.gtag = window.gtag || function gtag(){(window.dataLayer = window.dataLayer || []).push(arguments);};
    window.gtag('event', 'page_view', { page_path: window.location.pathname });
  }, []);

  return null;
};

export default GoogleAnalytics;
